import { render, staticRenderFns } from "./AppHotelCard.vue?vue&type=template&id=dcc890c8&scoped=true&"
import script from "./AppHotelCard.vue?vue&type=script&lang=js&"
export * from "./AppHotelCard.vue?vue&type=script&lang=js&"
import style0 from "./AppHotelCard.vue?vue&type=style&index=0&id=dcc890c8&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcc890c8",
  null
  
)

export default component.exports